import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { Location } from '@angular/common';
import { Title, Meta } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { Platform } from '@ionic/angular';
import { VhViethasWebAPPEndUser } from 'vhwebapp';
import path from '../../config/path/path.json'
@Component({
  selector: 'app-webapp-products-c001-user',
  templateUrl: './webapp-products-c001-user.component.html',
  styleUrls: ['./webapp-products-c001-user.component.scss']
})
export class WebappProductsC001UserComponent implements OnInit {

  @ViewChild('paginator', { static: true }) paginator: MatPaginator;
  listProduct: any = []; ///listProduct dùng để chưa dữ liệu được lưu từ data json
  itemFilter: any; // loại tên bộ lọc
  listShowCurrent: Array<any> = []; // danh sách hiển thị ra màn hình hiện tại
  term: string; // chuỗi để lưu chuỗi khi tìm kiếm
  isMobile: boolean;
  pageCurrentActive: number; // Thứ tự trang đang active
  categoryFilter: string;
  isLoading: boolean = false;
  totalPage: number = 1;
  page: number = 1;
  limit: number = 24;
  data_home: any
  id_category: any;
  routeParams: any
  constructor(
    private route: ActivatedRoute,
    public platform: Platform,
    private router: Router,
    private location: Location,
    private vhViethasWebAPPEndUser: VhViethasWebAPPEndUser,
    public titleService: Title,
    public metaTagService: Meta
  ) {
    if (this.platform.is('desktop')) this.isMobile = false;
    else this.isMobile = true;
    this.getDataField();
  }
  ngOnInit(): void {
    this.getPages();
  }

  getDataField() {
    this.isLoading = true
    this.route.params.subscribe(routeParams => {
      this.routeParams = routeParams
      this.id_category = routeParams.id_cate
      this.vhViethasWebAPPEndUser.getComponentContent('webapp_fields_c001s', routeParams.id_field)
        .then((response: any) => {
          console.log('fields', response);
          if (response.vcode === 0 && response.data.length != 0) {
            //-----------your code-----------
            this.data_home = response.data;
            this.titleService.setTitle(this.data_home.name + ' ' + '- Viethas cung cấp tất cả thiết bị bán hàng chuyên dụng');
            this.metaTagService.updateTag({ name: 'description', content: 'Thiết bị bán hàng chuyên dụng, máy in mã vạch, máy in nhiệt, máy cnc mini' })
            this.isLoading = false
          }
        }, error => {
          this.isLoading = false
          console.log('error', error);
        })
    })
  }

  formatInitName(_value) {
    return _value.split('-').join(' ')
  }

  getPages() {
    this.isLoading = true;
    this.route.params.subscribe((routeParams) => {
      this.page = Number(routeParams.number);
      if (routeParams.id_sub_category) {
        this.vhViethasWebAPPEndUser.getComponentContentsByFields(
          'webapp_fields_c001_items',
          { webapp_products_hidden: { $eq: true }, id_webapp_fields_c001_category: { $eq: routeParams.id_category }, id_sub_webapp_fields_c001_category: { $eq: routeParams.id_sub_category } }, {}, {}, this.limit, this.page)
          .then(
            (response: any) => {
              console.log('co subs', response);
              if (response.vcode === 0) {
                //-----------your code-----------
                this.listShowCurrent = response.data;
                this.totalPage = response.totalpages;
                this.isLoading = false;
              }
            },
            (error) => {
              this.isLoading = false;
              console.log('error', error);
            }
          );
      } else {
        this.vhViethasWebAPPEndUser
          .getComponentContentsByFields(
            'webapp_fields_c001_items',
            { webapp_products_hidden: { $eq: true }, id_webapp_fields_c001_category: { $eq: routeParams.id_category } }, {}, {}, this.limit, this.page)

          .then(
            (response: any) => {
              console.log('ko subs', response)
              if (response.vcode === 0) {
                //-----------your code-----------
                this.listShowCurrent = response.data;
                this.totalPage = response.totalpages;
                this.isLoading = false;
              }
            },
            (error) => {
              this.isLoading = false;
              console.log('error', error);
            }
          );
      }
    });
  }
  search() {
    this.getProductSearch()
  }

  getProductSearch() {
    this.isLoading = true;
    this.vhViethasWebAPPEndUser.searchList('webapp_fields_c001_items', ["name"], this.term, this.limit, this.page)
      .then((response: any) => {
        if (response.vcode === 0) {
          //-----------your code-----------
          this.listShowCurrent = response.data.filter(item => item.id_webapp_fields_c001_category == this.id_category && item.webapp_products_hidden == true);
          this.isLoading = false;
        }
      }, error => {
        console.log('error', error)
      })
  }

  // make list number page
  counter(i) {
    return new Array(i);
  }
  /** Chuyển về trang trước đó
   *
   */
  previewFn(): void {
    if (this.page > 1) {
      var pre: number = Number(this.page) - 1; // giá trị trang sẽ chuyển
      this.page = pre;
      let stringUrl =
        this.location.path().split('/').slice(0, -1).join('/') + '/' + pre; //cấu hình đường dẫn sẽ chuyển
      this.router.navigateByUrl(stringUrl); // chuyển trang
    }
  }
  /** Chuyển đến trang kế tiếp
   *
   */
  nextFn(): void {

    if (this.page < this.totalPage) {
      var next: number = Number(this.page) + 1; // giá trị trang sẽ chuyển
      this.page = next;
      let stringUrl =
        this.location.path().split('/').slice(0, -1).join('/') + '/' + next; //cấu hình đường dẫn sẽ chuyển
      this.router.navigateByUrl(stringUrl);
    }
  }
  /** Chuyển trang
   *
   * @param value
   */
  transferFn(value: number): void {
    let stringUrl =
      this.location.path().split('/').slice(0, -1).join('/') +
      '/' +
      String(value);
    this.page = value;
    this.router.navigateByUrl(stringUrl);
  }

  /** Trang đang active
   *
   * @param _value
   * @returns
   */

  checkPageActive(_value): boolean {
    if (_value == this.page) {
      return true;
    }
    return false;
  }

  gotoDetail(pro) {
    this.router.navigateByUrl(path.link + '/' + this.routeParams.id_field + '/' + pro._id)
  }
  /**Hàm kiểm tra có khuyến mãi  
  *  
   * @param _value
   * @return true false
   */
  checkDiscount(_value): boolean {
    if (_value !== undefined) {
      return true;
    }
    return false;
  }
  /** Hàm tính số tiền còn lại khi đã khuyến mãi
   *  
   *  
    * @param _price 
    * @param _discount 
    * @return number
    */
  sum(_price, _discount): number {
    if (_discount) {
      let discounted = (_discount / _price) * 100;
      return Math.round(100 - discounted);
    }
    else {
      return 0
    }
  }
  isNumber(val): boolean { return typeof val === 'number'; }

}
